import { render, staticRenderFns } from "./PatientResults.vue?vue&type=template&id=b07fe290&scoped=true&"
import script from "./PatientResults.vue?vue&type=script&lang=ts&"
export * from "./PatientResults.vue?vue&type=script&lang=ts&"
import style0 from "./PatientResults.vue?vue&type=style&index=0&id=b07fe290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07fe290",
  null
  
)

export default component.exports